<template>
  <div v-if="error" class="sp-notice sp-error" role="alert">
    <p>{{ error }}</p>
    <button v-if="retry" type="button" class="sp-link" @click="$emit('retry')">
      Try again
    </button>
  </div>
  <p v-if="loading" class="sp-notice" role="status">Loading…</p>
  <p v-if="success" class="sp-notice sp-success" role="status">{{ success }}</p>
</template>

<script>
export default {
  props: {
    error: {type: String, default: ''},
    loading: Boolean,
    success: {type: String, default: ''},
    retry: Boolean,
  },
  emits: ['retry'],
};
</script>
